module.exports = __webpack_public_path__ + "img/icon-faq-discover.4affbdd5.svg";